
import * as yup from 'yup';
import { useFormik } from "formik";
import UseGetDataSearchByPro from "../../../Components/Hooks/useFetchDataByPRO";

import SearchBar from "../../../Components/Utils/SearchBar";
import { CancelButton, ClearFilterButton, CreateButton, ExportButton, FilterButton, ImportButton, SubmitButton } from "../../../Components/Utils/Buttons";
import { GetAccess, GetRole } from "../../../Components/Utils/roles";
import CustomDataTable from "../../../Components/Others/CustomDataTable";
import Pagination from "../../../Components/Utils/Pagenation";
import { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import useFetchMetaStarIndex from "../../../Components/Hooks/useFetchMetaStarIndex";
import useFetchMDIndex from "../../../Components/Hooks/useFetchMDIndex";
import Breadcrumb from '../../../Components/Utils/Breadcrumb';
import List from '../../../Components/Icons/list';
import Card from '../../../Components/Icons/card';
import UseGetDataSearchByProUser from '../../../Components/Hooks/useFetchDataByPROUser';
import UseGetDataSearch from '../../../Components/Hooks/useFetchDataBySearch';
import CloseIcon from '../../../Components/Icons/Close';
import axiosInstance from '../../../Services/axiosCommon';
import NuDate from '../../../Components/Utils/NuDate';
import FormikSelectTwo from '../../../Components/Utils/Select';
import MobileTaskIndex from '../../Mobile/Tasks/MobileTaskIndex';
import ImportTask from './ImportTask';
import MultiEditTask from './MultiEditTask';
let dummyData = [
  {
    sno:1,
    taskId: 1,
    client: "Client 1",
    Activity: "Numota",
    StartDate:"2025-03-24",
    DueDate:"2026-03-24",
    Duration:"One Year",
    Priority:"High",
    Status: "Completed"
  },
  {sno:2,
    taskId: 2,
    client: "Client 2",
    Activity: "Accenture",
    StartDate:"2025-03-24",
    DueDate:"2026-03-24",
    Duration:"One Year",
    Priority:"low",
    Status: "Pending"
  },
  {sno:3,
    taskId: 3,
    client: "Client 3",
    Activity: "Wipro",
    StartDate:"2025-03-24",
    DueDate:"2026-03-24",
    Duration:"One Year",
    Priority:"Medium",
    Status: "Completed"
  },
  {sno:4,
    taskId: 4,
    client: "Client 4",
    Activity: "Google",
    StartDate:"2025-03-24",
    DueDate:"2026-03-24",
    Duration:"One Year",
    Priority:"High",
    Status: "Pending"
  },
  {sno:5,
    taskId: 5,
    client: "Client 5",
    Activity: "Zoho",
    StartDate:"2025-03-24",
    DueDate:"2026-03-24",
    Duration:"One Year",
    Priority:"Meddium",
    Status: "Completed"
  }

]


function Taskindex() {
   const [open, setOpen] = useState(false);
   const location = useLocation();
   const state = location.state;
  const {officeId}=useParams();
   const currentPage= location.state?.currentPage
   const searchQuery= location.state?.searchQuery
   const [page, setPage] = useState(currentPage||1)
   const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)
   const [filter, setFilter] = useState(state?.industry?true:false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
    const [filterProps, setFilterProps] = useState({
    
        Status:"",
   
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    // search:searchQuery||"",

    // searchBy: "",
    // country:"",
    // // category:state?.category? state.category :"",

    // category:"",
    // paymentTerm:"",
    // ratings:"",
    // status:"",
    // industry:state?.industry? state.industry :"",
    Status:"",
    // approvalStatus:"",

  });
  const clearFilter = ()=> {
    setParams({...params, 

      Status:""})
      formik.values.Status=""
         setFilter(false)
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      console.log("ffff",value);
      setParams({...params,Status:value.Status})
      closeFilterDialog();
      setFilter(true)
      setFilterProps({
       
        Status:"",
      
      });
    }
  })

  
  const { data, totalCount, getData,dataLoading } = UseGetDataSearchByProUser( `/employees/${officeId}/details`, params );
  const [viewMode, setViewMode] = useState(localStorage.getItem("viewMode") || "card");
  const defaultHeader = [
    {
      title: "Activity",
      width: "5%",
      field: "Activity",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "StartDate",
      type:"date",
      width: "10%",
      isLink: true,
      id: "taskId",
      link: `/tasks/view/`,
      field: "StartDate",
      textAlign: "center",
      rowAlign: "center",
    },
   
    {
      title: "Due Date ",
      width: "10%",
      type: "date",
      field: "DueDate",
      textAlign: "center",
      rowAlign: "center",
    },
    
    {
      title: "Duration",
      width: "10%",
      field: "Duration",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Priority",
      width: "10%",
      field: "Priority",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Status ",
      width: "10%",
      field: "Status",
      textAlign: "center",
      rowAlign: "center",
    },
   
    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents:{
        // fetcher:getData,
        id:"taskId",
        removeValue:"firstName",
        url:`/tasks/`,
        moduleName:"Tasks",
        from:`/tasks/`,
        editLink:`/tasks/edit/`,
        viewLink:`/tasks/view/`

      }
    },
  ];
  const availableHeaders = [

   
  ];
  useEffect(()=>{
    localStorage.setItem("viewMode", viewMode);
     setParams({...params,page:page,per_page:pageCount})
 },[page,pageCount,viewMode])

 const closeFilterDialog = () => {
  setShowFilterDialog(false);
};
const [showImportModal, setShowImportModal] = useState(false);

  const handleImportClick = () => {
    setShowImportModal(true);
  };
  const [screenSize, setScreenSize] = useState({
             width: window.innerWidth,
           });
         
           useEffect(() => {
             const handleResize = () => {
               setScreenSize({
                 width: window.innerWidth,
               });
             };
         
             window.addEventListener("resize", handleResize);
         
             return () => {
               window.removeEventListener("resize", handleResize);
             };
           }, []);

  const closeModal = () => {
    setShowImportModal(false);
  };
  const [showExport, setShowExport] = useState(false);
  const [exportValue, setExportValue] = useState({
    type: "all",
    approvalStatus: "",
    salesPerson: "",
    status: "",
    leadTime: "",
    validity: "",
    availability: "",
    paymentMethod: "",
    paymentTerms: "",
    deliveryTerms: "",
    fromDate: "",
    toDate: "",
  });
  const ExportFormik = useFormik({
    enableReinitialize: true,
    initialValues: exportValue,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value, { resetForm }) => {

      try {
        const response = await axiosInstance.get(`/customer-quotations/export-to-excel?approvalStatus=${value.approvalStatus}&salesPerson=${value.salesPerson}&status=${value.status}&leadTime=${value.leadTime}&validity=${value.validity}&availability=${value.availability}&paymentMethod=${value.paymentMethod}&paymentTerms=${value.paymentTerms}&deliveryTerms=${value.deliveryTerms}&fromDate=${value.fromDate}&toDate=${value.toDate}`, {
            responseType: 'blob' // Important to specify the response type as blob
        });

        // Create a Blob from the response
        const pdfBlob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        // Create a link element
       
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(pdfBlob);
        link.download = `CQ Report ${NuDate({value:new Date(), format:"DD-MMM-YYYY"})}.xlsx`; // The filename you want for the downloaded file

        // Append the link to the body (required for Firefox)
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);

    } catch (error) {
        console.error('Error downloading the PDF:', error);
    }
    },
  });
  const closeFilterDialogebox = () => {
    setShowExport(false);
  };


      const [showEdit, setShowEdit] = useState(false)
      const [listofNumbers, setListofNumbers] = useState([])
      const [fullList, setFullList] = useState([])
    
      const selectOneFunction = (value) =>{ 
        console.log("sss",value);
       
        let NewId;
        if(listofNumbers && listofNumbers.some(Item=>Item ===value)){
          NewId = listofNumbers.filter(Temp=> Temp !== value);
          setListofNumbers(NewId)
        }else{
          setListofNumbers([...listofNumbers,value])
        }
        console.log("sss",listofNumbers);
      }
    
      const selectMultipleFunction = (e) =>{ 
    if(e.target.checked){
      console.log("if List",fullList);
      setListofNumbers(fullList)
    }else{
      console.log("else List",fullList);
      setListofNumbers([])
    }
    
      }
    
      useEffect(()=>{
        let tempArr = []
        data && data.forEach(i=>{
          console.log("I",i);
          tempArr.push(i?.taskId)
        });
        setFullList(tempArr)
      },[data])


  return (
    <div className='w-full h-full px-4 py-2'>
      <div className='w-full flex justify-between items-center'>
        <Breadcrumb
         items={[
          {
            name: "Task",

          },
        

          ]} />
        <div className=' flex gap-2'>
        <SearchBar
              handleChange={(e) =>{
                setParams({ ...params, search: e.target.value, page:1 });
                setPage(1)
              }}
              value={params.search||searchQuery}
            />
          {/* <div className='flex gap-2'>
            <div onClick={() => setViewMode("list")} className={viewMode === "list" ? "bg-baseColor-primary h-8 w-10 rounded-md flex justify-center items-center text-white" : "bg-white h-8 w-10 rounded-md flex justify-center items-center cursor-pointer"}><List/></div>
            <div onClick={() => setViewMode("card")} className={viewMode === "card" ? "bg-baseColor-primary h-8 w-10 rounded-md flex justify-center items-center text-white" : "bg-white h-8 w-10 rounded-md flex justify-center items-center cursor-pointer"}><Card/></div>
          </div> */}
          <FilterButton  handleClick={()=>setShowFilterDialog(true)} />
          {filter && <ClearFilterButton  handleClick={()=>clearFilter()} label='Clear'/>}
        
            <ImportButton handleClick={handleImportClick} />
            {/* <ExportButton handleClick={() => setShowExport(true)}/> */}
             {/* <Link to={`/tasks/create`}><CreateButton label='Task' /></Link> */}

        </div>
      </div>
      {
   screenSize.width <= "786" ?(<>
   <div className=' w-full h-[calc(100vh-160px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden'>
   <MobileTaskIndex
   data={dummyData}
   total={totalCount}
   pageIndex={page}
   setPageIndex={setPage}
   dataCount={pageCount}
   setDataCount={setPageCount}
   officeId={officeId}
   getData={getData}
  
   />
   </div>
   </>):(<>
  
  
     <div className='w-full h-full  '>
       {/* <div className='w-full flex justify-between items-center'>
         <Breadcrumb
           items={[
             { name: "Procurement" },
             { name: "YPR" },
           ]} />
         <div className=' flex gap-2'>
         <SearchBar
               handleChange={(e) =>{
                 setParams({ ...params, search: e.target.value, page:1 });
                 setPage(1)
               }}
               value={params.search||searchQuery}
             />  <FilterButton  handleClick={()=>setShowFilterDialog(true)} />
           {filter && <FilterButton  handleClick={()=>clearFilter()} label='Clear'/>} */}
         
           {/* {GetAccess("purchase_request_create") && <ImportButton handleClick={handleImportClick} />} */}
           {/* {GetAccess("purchase_request_create") && <Link to={`/main/${officeId}/procurement/purchase-requests/create`}><CreateButton label='YPR' /></Link>}
         </div>
       </div> */}
  
  
      <CustomDataTable 
        fetcher={getData}
        // data={data}
        data={dummyData}  
        availableHeaders={availableHeaders} 
        defaultHeader={defaultHeader}
        bodyHeight='max-h-[calc(100vh-260px)]'
        height='h-[calc(100vh-155px)]'
        total={totalCount}
        pageIndex={params.page}
        setPageIndex={setPage}
        dataCount={params.per_page}
        setDataCount={setPageCount}
        // title='Employee List'
        storageName="TaskTable"
        editAccess="task_edit"      
        deteleAccess="task_delete" 
        dataLoading={dataLoading}
        searchQuery={params?.search!=""?params?.search:""}
        hasMultiEdit={true}
        selectOneFunction={selectOneFunction}
        setShowEdit={setShowEdit}
        showEdit={showEdit}
        listofNumbers={listofNumbers}
        selectMultipleFunction={selectMultipleFunction}
        fullList={fullList}
        getById='taskId'
        />
         </div>
  
  </>)}
       
        {/* <>
        <div className='w-full h-[calc(100vh-190px)] rounded-md bg-white p-3 mt-4 relative overflow-y-scroll'>
       <div className='flex gap-40'>
      
        <p className='text-xs font-semibold text-[#111537] text-left'>Employee : {totalCount}</p>
     

       
        </div>
          <div className='w-full flex justify-start flex-wrap md:gap-x-5 lg:gap-x-6 gap-y-6 pt-4'>
            
            {data && data.map((item, idx) => (
              <EmployeeCard fetcher={getData} item={item} key={idx} />
            ))}
          </div>
        </div>
        <div className="w-full h-[40px] rounded-b-md bg-white">
          <Pagination
            total={totalCount}
            pageIndex={page}
            setPageIndex={setPage}
            dataCount={pageCount}
            setDataCount={setPageCount}
          />
        </div>
        </> */}
        
      
       {showFilterDialog && (
             
             
             <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
               <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
                 <h2 className="text-xl mb-4">Filter </h2>
                 <form onSubmit={formik.handleSubmit}> 
                    <div className="flex flex-col mb-4">
                  
                    <FormikSelectTwo
               label="Status"
               Options={[
                  { value: "Completed", label: "Completed" },
                  { value: "Pending", label: "Pending" },
               ]}
               formik={formik}
               placeholder="Choose"
               name="Status"
               isRequired={true}
               width="w-full  md:-mt-2"
             />
                     
                    </div>
                   <div className="flex justify-end gap-2">
                     <CancelButton handleClick={closeFilterDialog} />
                     <SubmitButton name='Apply' />
                   </div>
                  </form> 
               </div>
             </div>
           )}
         
      {showEdit && (<MultiEditTask data={listofNumbers} getData={getData} onClose={()=>setShowEdit(false)}/>)}
          {showImportModal && (<ImportTask show={showImportModal} onClose={closeModal} getData={getData} />)}
          {/* <ImportTask
        open={open}
        onCancel={() => setOpen(false)}
        getData={getData}
        officeId={officeId}
        label="Import"
      />    */}
          </div>
  )
}
 
export default Taskindex;